import {
  apiGetSignals,
  apiGetSignalsFiltered,
  apiGetSignalsSorted,
} from "@/Groups/Signals/private/api/signalsApi";

// Поиск по названию/описанию: перезагружает список, совмещая q
// с активными фильтром и сортировкой (все ортогональны на бэкенде)
export const applySearch = async ({ commit, state }, q) => {
  commit("SET_SEARCH_QUERY", q);
  commit("TOGGLE_LOADING_FLAG", true);

  try {
    let data;
    if (state.activeSort) {
      data = await apiGetSignalsSorted(state.activeSort.key, state.activeSort.direction, null, q);
    } else if (state.activeFilter) {
      data = await apiGetSignalsFiltered(state.activeFilter, null, q);
    } else {
      data = await apiGetSignals(null, q);
    }

    // Гонка ответов при быстром стирании строки: ответ устаревшего запроса
    // (q=bi) может прийти позже ответа без q и перетереть уже сброшенный список
    if (state.searchQuery !== q) return;

    commit("CLEAR_DATA");
    commit("SET_DATA", data.results);
    commit("SET_NEW_LINK", data.next || null);

    if (!state.activeSort) commit("SORT_SIGNALS");
  } catch (err) {
    console.error("Ошибка поиска сигналов:", err);
    throw err;
  } finally {
    commit("TOGGLE_LOADING_FLAG", false);
  }
};

// Сброс поисковой строки (уход со страницы) — данные не трогает
export const resetSearch = ({ commit }) => {
  commit("SET_SEARCH_QUERY", "");
};
